import _ from "lodash";
import { createSelector } from 'reselect';
import parseAccountName from "../utils/parseAccountName";
import { ACCOUNT_TYPES } from "./appConstants.js";

const moduleSelector = state => state.app;
const routerSelector = state => state.router;

export const makeSelectAppInited = () =>
    createSelector(
        moduleSelector,
        state => state.inited,
    );

export const makeSelectAppLocale = () =>
    createSelector(
        moduleSelector,
        state => state.locale,
    );

export const makeSelectAppLang = () =>
    createSelector(
        moduleSelector,
        state => state.lang,
    );

export const makeSelectAppLoggedIn = () =>
    createSelector(
        moduleSelector,
        state => state.loggedIn,
    );

export const makeSelectAppLoggedInProcess = () =>
    createSelector(
        moduleSelector,
        state => state.loggedInProcess,
    );


export const makeSelectAppFormError = () =>
    createSelector(
        moduleSelector,
        state => state.formError,
    );

export const makeSelectPasswordResetSent = () =>
    createSelector(
        moduleSelector,
        state => state.passwordResetSent,
    );

export const getAppUser = createSelector(
    moduleSelector, state => state.user,
);

export const getAvailableCountries = createSelector(
    moduleSelector, state => state.availableCountries,
);

export const getOpenedModalSelector = createSelector(
    moduleSelector, state => state.openedModal,
);

export const getOpenedModalParamsSelector = createSelector(
    getOpenedModalSelector, state => state?.params,
);

export const makeSelectOpenedModalPrevious = () =>
    createSelector(
        moduleSelector,
        state => state.openedModalPrevious,
    );

export const getRegistrationData = createSelector(
    moduleSelector, state => state.registration,
);

export const makeSelectChangeEmail = () =>
    createSelector(
        moduleSelector,
        state => state.changeEmail,
    );

export const getCodeChecked = createSelector(
    moduleSelector, state => state.codeChecked
);

export const makeSelectAvailableLocales = () =>
    createSelector(moduleSelector, state => state?.availableLocales || []);

export const makeSelectAppKeys = () =>
    createSelector(moduleSelector, state => state?.appKeys || {});

export const makeSelectRoutePathname = () =>
    createSelector(routerSelector, routerState => routerState?.location?.pathname || '');

export const getIsCheckCodeLoading = createSelector(
    moduleSelector, state => state.isCheckCodeLoading
);

export const getPasswordMaxLengthSelector =
    createSelector(moduleSelector, state => state?.passwordMaxLength || 40);

export const getPasswordMinLengthSelector =
    createSelector(moduleSelector, state => state?.passwordMinLength || 8);

export const getUserEmailSelector = createSelector(
    getAppUser, user => user?.email || ''
);

export const getUserDefaultAccountCode = createSelector(
    getAppUser, user => user?.defaultAccountCode || ''
);

export const getUserSelectedAccountCode = createSelector(
    moduleSelector, state => state.selectedAccountCode
);

export const getUserSelectedAccountType = createSelector(
    getUserSelectedAccountCode, state => parseAccountName(state)?.type,
);

export const getIsUserSelectedAccountTypeLive = createSelector(
    getUserSelectedAccountType, state => state === ACCOUNT_TYPES.LIVE,
);

export const getUserAccountsSelector = createSelector(
    getAppUser, state => state?.accounts || []
);

export const getIsUserBuyerSelector = createSelector(
    getAppUser, state => state.buyer
);

export const getUserHasLiveAccount = createSelector(
    getUserAccountsSelector, accounts => {
        return !!_.some(accounts, { type: ACCOUNT_TYPES.LIVE });
    }
);

export const getAbTestsSelector = createSelector(
    moduleSelector, state => state.abTests || {}
);

export const getUserUidSelector = createSelector(
    getAppUser, user => user.uid || null
);

export const getUserEmailConfirmedSelector = createSelector(
    getAppUser, state => state.email_confirmed || false,
);

export const getIsFirstLoginSelector = createSelector(
    moduleSelector, state => state.isFirstLogin
);

export const makeSelectPartnerParams = () => createSelector(
    moduleSelector, state => state.partner
);

export const getOnboardingCompleted = createSelector(
    moduleSelector, state => state.onboardingCompleted
);

export const getOnboardingCompleteLoading = createSelector(
    moduleSelector, state => state.onboardingCompleteLoading
);

export const getAppFeatures = createSelector(
    moduleSelector, state => state.features || {}
);

export const getAppIsCreatePasswordLoading = createSelector(
    moduleSelector, state => state.isCreatePasswordLoading || false,
);

export const getAccountsTradeInfoSelector = createSelector(
    moduleSelector, state => state.accountsTradeInfo || {},
);

export const getUserRecents = createSelector(
    getAppUser, state => state?.recents || {}
);

export const getPadVersion = createSelector(
    moduleSelector, state => state.padVersion
);

export const getIsOpenMobileAppBannerVisible = createSelector(
    moduleSelector, state => state.isOpenMobileAppBannerVisible,
);

export const getIsAppVisibility = createSelector(
    moduleSelector, state => state.visibility,
);

export const getIsOpenRespawnBannerVisible = createSelector(
    moduleSelector, state => state.isOpenRespawnBannerVisible,
);
